/*
  ss-subscribe.js · compra y suscripción de salt&spirit. (pliego §3.2-bis, §3.2 swap, §3.6 sticky, §3.7 galería)
  Todas las funciones son globales y se definen UNA vez (onclick="window.fn(this)": sobreviven innerHTML y
  el clon de <main> de HTMLUpdateUtility.viewTransition). Sin addEventListener('change') en controles.
  Ningún fetch propio para agregar: el submit lo hace product-form.js de Dawn (candado aria-disabled);
  el sticky solo llama a requestSubmit() del form real, con su propio candado __adding.

  API:
    ssPlan(radio) · ssFreq(chip) · ssPickFormula(el) (home) · ssSwapFormula(a, ev) (PDP)
    ssStickySubmit(btn) · ssReapplyFreq(root) · ssBuyInit(root) · ssBuyTeardown(root)
    ssBuyGal(tab) · ssBuyZoom(btn) · ssBuyAcc(btn)
  Integración con ss-motion.js (C1): aquí se definen window.ssInit/ssTeardown (compra); ss-motion.js las envuelve.
  ssSwapFormula llama a ssTeardown(oldMain) y ssInit(newMain). Todo idempotente (data-ss-buy-ready).
*/
(function () {
  if (window.__ssSubscribeLoaded) return;
  window.__ssSubscribeLoaded = true;

  var GAL_MS = 3806;
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var GALS = [];
  var __adding = false;

  /* __ssFreq: la cadencia elegida se conserva al cambiar de fórmula (home y PDP). */
  if (!window.__ssFreq) window.__ssFreq = null;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }

  /* ---------- selector de plan ---------- */

  function activeSource(po) {
    var mode = po.getAttribute('data-mode') || 'sub';
    if (mode === 'once') return $('[data-ss-row="once"]', po);
    return $('.ss-po__chip[aria-pressed="true"]', po) || $('.ss-po__chip', po);
  }

  function paint(po) {
    var uid = po.getAttribute('data-uid');
    var mode = po.getAttribute('data-mode') || 'sub';
    var src = activeSource(po);
    if (!src) return;
    var d = src.dataset;

    $$('.ss-po__row', po).forEach(function (row) {
      row.classList.toggle('is-active', row.getAttribute('data-ss-row') === mode);
    });

    var sp = $('[data-ss-sp]', po);
    if (sp) {
      if (mode === 'sub' && d.plan) { sp.value = d.plan; sp.disabled = false; }
      else { sp.disabled = true; }
    }

    if (mode === 'sub') {
      var subWas = $('[data-ss-sub-was]', po);
      if (subWas) { setText(subWas, d.was || ''); subWas.hidden = !d.was; }
      setText($('[data-ss-sub-now]', po), d.price || '');
      setText($('[data-ss-charge]', po), d.charge || '');
      var save = $('[data-ss-save]', po);
      if (save) { setText(save, d.save || ''); save.hidden = !d.save; }
    }

    var price = document.getElementById('ss-price-' + uid);
    if (price) {
      setText($('[data-ss-now]', price), d.price || '');
      var per = $('[data-ss-per]', price);
      if (per && d.per) setText(per, d.per);
    }

    var btn = document.getElementById('ProductSubmitButton-' + uid);
    if (btn && !btn.disabled) {
      var lbl = $('[data-ss-btn-label]', btn) || btn.querySelector('span');
      if (lbl && d.btn) setText(lbl, d.btn);
    }

    var st = document.getElementById('ss-sticky-' + uid);
    if (st) {
      setText($('[data-ss-sticky-plan]', st), d.planLabel || '');
      if (d.stickyBtn) setText($('[data-ss-sticky-btn]', st), d.stickyBtn);
    }
  }

  window.ssPlan = function (el) {
    if (!el || el.disabled) return;
    var po = el.closest('[data-ss-po]');
    if (!po || po.hasAttribute('data-ss-preview')) return;
    var mode = el.value === 'once' ? 'once' : 'sub';
    el.checked = true;
    po.setAttribute('data-mode', mode);
    paint(po);
    var chip = mode === 'sub' ? activeSource(po) : null;
    window.__ssFreq = { mode: mode, days: chip ? chip.getAttribute('data-days') || '' : '' };
  };

  window.ssFreq = function (el) {
    if (!el || el.disabled) return;
    var po = el.closest('[data-ss-po]');
    if (!po || po.hasAttribute('data-ss-preview')) return;
    $$('.ss-po__chip', po).forEach(function (c) { c.setAttribute('aria-pressed', c === el ? 'true' : 'false'); });
    var sub = $('input[value="sub"]', po);
    if (sub) window.ssPlan(sub);
  };

  function applyFreq(po) {
    var f = window.__ssFreq;
    if (!po || po.hasAttribute('data-ss-preview')) return;
    if (f && f.mode === 'once') {
      var once = $('input[value="once"]', po);
      if (once) { window.ssPlan(once); return; }
    }
    if (f && f.mode === 'sub' && f.days) {
      var chip = $('.ss-po__chip[data-days="' + f.days + '"]', po);
      if (chip && !chip.disabled) {
        $$('.ss-po__chip', po).forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      }
    }
    var saved = window.__ssFreq;
    var sub = $('input[value="sub"]', po);
    if (sub) { po.setAttribute('data-mode', 'sub'); sub.checked = true; }
    paint(po);
    window.__ssFreq = saved;
  }

  window.ssReapplyFreq = function (root) {
    $$('[data-ss-po]', root || document).forEach(applyFreq);
  };

  /* ---------- selector de fórmula · home ---------- */

  function pickPanel(buy, h) {
    var target = $('[data-ss-panel="' + h + '"]', buy);
    if (!target) return null;
    if (target.hidden) {
      $$('[data-ss-panel]', buy).forEach(function (p) {
        var on = p === target;
        p.hidden = !on;
        if (on) p.removeAttribute('inert'); else p.setAttribute('inert', '');
      });
      applyFreq($('[data-ss-po]', target));
      syncGalleries(buy);
      try { fselReveal(target); } catch (e) {}
    }
    return target;
  }

  window.ssPickFormula = function (el) {
    var h = el && el.getAttribute && el.getAttribute('data-ss-pick');
    var buy = document.querySelector('[data-ss-buy="home"]');
    if (!h || !buy) return true;
    var target = pickPanel(buy, h);
    if (!target) return true;
    if (buy.contains(el)) {
      var pill = $('.ss-fpill[data-ss-pick="' + h + '"]', target);
      if (pill) { try { pill.focus({ preventScroll: true }); } catch (e) { pill.focus(); } }
      return false;
    }
    /* Enlace desde otra sección (tarjeta de S03, etc.): con href="#comprar" el ancla hace el scroll. */
    var href = el.getAttribute('href') || '';
    if (href.indexOf('#comprar') === 0) return true;
    buy.scrollIntoView({ behavior: RM.matches ? 'auto' : 'smooth', block: 'start' });
    return false;
  };

  /* ---------- selector de fórmula · PDP (swap de <main>) ---------- */

  function doSwap(href, push) {
    return fetch(href, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (txt) {
        var html = new DOMParser().parseFromString(txt, 'text/html');
        var newMain = html.querySelector('main');
        var oldMain = document.querySelector('main');
        if (!newMain || !oldMain || typeof HTMLUpdateUtility === 'undefined') throw new Error('swap');
        /* ssTeardown/ssInit = compra (este archivo) + movimiento (ss-motion.js las envuelve). */
        try { window.ssTeardown(oldMain); } catch (e) { console.error(e); window.ssBuyTeardown(oldMain); }
        HTMLUpdateUtility.viewTransition(oldMain, newMain, [], [function (n) {
          try { window.ssInit(n); } catch (e) { console.error(e); window.ssBuyInit(n); }
        }]);
        if (push) history.pushState({ ssSwap: 1 }, '', href);
        if (html.title) document.title = html.title;
      });
  }

  window.ssSwapFormula = function (el, ev) {
    if (ev && (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button > 0)) return true;
    if (!el || !window.fetch || !window.DOMParser || !window.history || typeof HTMLUpdateUtility === 'undefined') return true;
    if (el.getAttribute('aria-current') === 'page') return false;
    var href = el.href;
    el.setAttribute('aria-busy', 'true');
    doSwap(href, true).catch(function (e) { console.error(e); window.location.href = href; });
    return false;
  };

  window.addEventListener('popstate', function (e) {
    if (!e.state || !e.state.ssSwap) return;
    if (!document.querySelector('[data-ss-buy="pdp"]')) return;
    doSwap(window.location.href, false).catch(function () { window.location.reload(); });
  });

  /* ---------- sticky ATC (solo PDP ≤809; la visibilidad la decide CSS + estas clases) ---------- */

  window.ssStickySubmit = function (el) {
    var form = el && document.getElementById(el.getAttribute('data-form'));
    if (!form || __adding) return;
    var btn = form.querySelector('[type="submit"]');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    __adding = true;
    setTimeout(function () { __adding = false; }, 1500);
    if (typeof form.requestSubmit === 'function') form.requestSubmit(btn);
    else btn.click();
  };

  function initSticky(st) {
    if (st.hasAttribute('data-ss-buy-ready')) return;
    st.setAttribute('data-ss-buy-ready', '');
    var real = document.getElementById(st.getAttribute('data-btn'));
    if (!real || !('IntersectionObserver' in window)) return;
    var state = { above: false, stops: new Set() };
    var sbtn = $('.ss-sticky-atc__btn', st);
    function update() {
      /* 29-sep: no aparece al cargar (a 350 tapaba las píldoras); sale tras el primer scroll si el botón no se ve */
      /* 19-oct · B: con pantalla de ≥560 px la barra sale desde el inicio (el botón real queda abajo del pliegue en móvil) */
      var on = state.above && state.stops.size === 0 && !real.disabled && (window.__ssScrolledOnce === true || window.innerHeight >= 560);
      st.classList.toggle('is-on', on);
      st.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (sbtn) sbtn.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('ss-sticky-on', on);
    }
    var io1 = new IntersectionObserver(function (es) {
      es.forEach(function (e) { state.above = !e.isIntersecting; });
      update();
    });
    io1.observe(real);
    if (!window.__ssScrolledOnce) {
      var onSc = function () { if (window.scrollY > 40) { window.__ssScrolledOnce = true; window.removeEventListener('scroll', onSc); update(); } };
      window.addEventListener('scroll', onSc, { passive: true });
    }
    /* Una parada cuenta cuando ya ocupa la mitad superior del viewport (rootMargin -50 % abajo): con una PDP corta,
       «otras fórmulas» asoma en cuanto el botón sale y la barra no llegaría a verse nunca. */
    function onStops(es) {
      es.forEach(function (e) { if (e.isIntersecting) state.stops.add(e.target); else state.stops.delete(e.target); });
      update();
    }
    var io2 = new IntersectionObserver(onStops, { rootMargin: '0px 0px -50% 0px' });
    Array.prototype.forEach.call(document.querySelectorAll('[data-ss-sticky-stop], [id$="__ss-other-formulas"]'), function (s) { io2.observe(s); });
    /* CTA y footer: la barra se retira en cuanto asoma 1 px de los botones de ss-cta (QA r1: tapaba «Comprar»;
       QA r2: observar la sección entera la apagaba durante todo el FAQ) o del footer */
    var io3 = new IntersectionObserver(onStops, { threshold: 0 });
    Array.prototype.forEach.call(document.querySelectorAll('.ss-cta__btns, .shopify-section-group-footer-group'), function (s) { io3.observe(s); });
    /* QA r2: las tarjetas de «Las otras fórmulas» pasan por la franja de 72 px de la barra: mientras una está ahí, la barra se retira */
    var io4 = null;
    function mkIo4() {
      if (io4) { io4.disconnect(); $$('.ss-pcard', document).forEach(function (c) { state.stops.delete(c); }); }
      io4 = new IntersectionObserver(onStops, { rootMargin: '-' + Math.max(0, window.innerHeight - 72) + 'px 0px 0px 0px' });
      Array.prototype.forEach.call(document.querySelectorAll('[id$="__ss-other-formulas"] .ss-pcard'), function (c) { io4.observe(c); });
      if (st.__ss) st.__ss.ios[3] = io4;
    }
    var rT = null, lastH = window.innerHeight;
    function onRs() {
      if (window.innerHeight === lastH) return;
      lastH = window.innerHeight;
      clearTimeout(rT); rT = setTimeout(function () { mkIo4(); update(); }, 150);
    }
    mkIo4();
    window.addEventListener('resize', onRs, { passive: true });
    st.__ss = { ios: [io1, io2, io3, io4], off: function () { window.removeEventListener('resize', onRs); clearTimeout(rT); st.classList.remove('is-on'); document.body.classList.remove('ss-sticky-on'); } };
  }

  /* ---------- galería (§3.7): 1 <img>, corte seco 3806 ms, tramos 4000 ms cortados al 95 % ---------- */

  function galTabs(g) { return $$('.ss-gal__tab', g); }

  function galGo(g, i, restart) {
    var tabs = galTabs(g);
    if (!tabs.length) return;
    var n = ((i % tabs.length) + tabs.length) % tabs.length;
    var t = tabs[n];
    var img = $('[data-ss-gal-img]', g);
    if (img && g.__ss.i !== n && !$('[data-ss-gal-track]', g)) {
      img.srcset = t.getAttribute('data-srcset');
      img.src = t.getAttribute('data-src');
      img.alt = t.getAttribute('data-alt') || '';
      img.setAttribute('data-zoom', t.getAttribute('data-zoom') || '');
    }
    g.__ss.i = n;
    tabs.forEach(function (x, k) {
      x.setAttribute('aria-selected', k === n ? 'true' : 'false');
      x.classList.remove('is-run');
    });
    var cnt = $('[data-ss-gal-n]', g);
    if (cnt) cnt.textContent = (n + 1 < 10 ? '0' : '') + (n + 1);
    var pills = $('[data-ss-gal-pills]', g);
    if (pills) pills.hidden = n !== 0;
    var nx = tabs[(n + 1) % tabs.length];
    if (nx && nx !== t) { var pre = new Image(); pre.sizes = img ? img.sizes : ''; pre.srcset = nx.getAttribute('data-srcset'); pre.src = nx.getAttribute('data-src'); }
    if (restart !== false) galSchedule(g);
  }

  function galStop(g) {
    if (g.__ss && g.__ss.t) { clearTimeout(g.__ss.t); g.__ss.t = null; }
    galTabs(g).forEach(function (x) { x.classList.remove('is-run'); });
  }

  function galSchedule(g) {
    galStop(g);
    if (!g.__ss || !g.__ss.vis || document.hidden || RM.matches) return;
    /* no cambiar la foto antes de la 1.ª interacción: el LCP se cierra ahí (QA r1) · tras una elección manual no se reanuda (WCAG 2.2.2) */
    if (!window.__ssInteracted || g.__ss.manual) return;
    if (g.hasAttribute('data-ss-gal-thumbs')) return; /* 29-sep: galería con miniaturas no avanza sola */
    if (g.offsetParent === null) return;
    var tabs = galTabs(g);
    if (tabs.length < 2) return;
    var cur = tabs[g.__ss.i];
    if (cur) { void cur.offsetWidth; cur.classList.add('is-run'); }
    g.__ss.t = setTimeout(function () { galGo(g, g.__ss.i + 1); }, GAL_MS);
  }

  function galManual(g, i) {
    if (!g.__ss) initGal(g);
    g.__ss.manual = true;
    galGo(g, i, false);
    galStop(g);
  }

  function bindGalInput(g) {
    if (g.__ssInputBound) return;
    g.__ssInputBound = true;
    /* deslizar sobre la foto (no es un control que Dawn re-renderice) */
    var frame = $('.ss-gal__frame', g);
    var track = $('[data-ss-gal-track]', g);
    if (track) {
      var st = null;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          if (!g.__ss) return;
          var n = galSlideIndex(track);
          if (n !== g.__ss.i) { galGo(g, n, false); galThumbIntoView(g); }
          galProg(g, n);
        }, 90);
      }, { passive: true });
    }
    if (frame && !track) {
      var sx = null, sy = 0, spid = null;
      frame.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; spid = e.pointerId; });
      frame.addEventListener('pointercancel', function () { sx = null; });
      frame.addEventListener('pointerup', function (e) {
        if (sx === null || e.pointerId !== spid || !g.__ss) { sx = null; return; }
        var dx = e.clientX - sx, dy = e.clientY - sy;
        sx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          g.__ss.swiped = true;
          setTimeout(function () { if (g.__ss) g.__ss.swiped = false; }, 400);
          galManual(g, g.__ss.i + (dx < 0 ? 1 : -1));
        }
      });
    }
    /* flechas del teclado entre pestañas (role=tab) */
    var bar = $('.ss-gal__bar', g);
    if (bar) {
      bar.addEventListener('keydown', function (e) {
        var k = e.key;
        if (k !== 'ArrowRight' && k !== 'ArrowLeft' && k !== 'Home' && k !== 'End') return;
        var tabs = galTabs(g);
        if (!tabs.length || !g.__ss) return;
        e.preventDefault();
        var n = k === 'Home' ? 0 : k === 'End' ? tabs.length - 1 : g.__ss.i + (k === 'ArrowRight' ? 1 : -1);
        n = ((n % tabs.length) + tabs.length) % tabs.length;
        galManual(g, n);
        tabs[n].focus();
      });
    }
  }

  function initGal(g) {
    if (g.hasAttribute('data-ss-buy-ready')) return;
    g.setAttribute('data-ss-buy-ready', '');
    g.__ss = { i: 0, t: null, vis: false, io: null, manual: false, swiped: false };
    GALS.push(g);
    bindGalInput(g);
    if ('IntersectionObserver' in window) {
      g.__ss.io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { g.__ss.vis = e.isIntersecting; });
        if (g.__ss.vis) galSchedule(g); else galStop(g);
      });
      g.__ss.io.observe(g);
    }
  }

  function syncGalleries(root) {
    $$('[data-ss-gal]', root).forEach(function (g) { if (g.__ss) { if (g.__ss.vis) galSchedule(g); else galStop(g); } });
  }

  window.ssBuyGalStep = function (btn, d) {
    var g = btn && btn.closest('[data-ss-gal]');
    if (!g) return;
    if (!g.__ss) initGal(g);
    galManual(g, g.__ss.i + d);
    var bar = $('.ss-gal__bar', g), t = galTabs(g)[g.__ss.i];
    if (bar && t) bar.scrollTo({ left: t.offsetLeft - (bar.clientWidth - t.offsetWidth) / 2, behavior: RM.matches ? 'auto' : 'smooth' });
  };

  /* 30-sep: la pista puede tener diapositivas más angostas que el marco (celular con la siguiente asomándose) */
  function galSlides(track) { return track ? track.querySelectorAll('.ss-gal__slide') : []; }
  function galSlideIndex(track) {
    var sl = galSlides(track); if (sl.length < 2) return 0;
    var step = sl[1].offsetLeft - sl[0].offsetLeft || track.clientWidth;
    return Math.max(0, Math.min(sl.length - 1, Math.round(track.scrollLeft / Math.max(1, step))));
  }
  function galProg(g, n) {
    var p = $('[data-ss-gal-prog]', g), c = galTabs(g).length || 1;
    if (p) p.style.transform = 'translateX(' + (n * 100) + '%)';
  }
  function galThumbIntoView(g) {
    var bar = $('.ss-gal__bar', g), t = galTabs(g)[g.__ss.i];
    if (!bar || !t) return;
    if (bar.scrollHeight > bar.clientHeight + 2) bar.scrollTo({ top: t.offsetTop - (bar.clientHeight - t.offsetHeight) / 2, behavior: RM.matches ? 'auto' : 'smooth' });
    else bar.scrollTo({ left: t.offsetLeft - (bar.clientWidth - t.offsetWidth) / 2, behavior: RM.matches ? 'auto' : 'smooth' });
  }

  window.ssBuyGal = function (tab) {
    var g = tab && tab.closest('[data-ss-gal]');
    if (!g) return;
    var i = parseInt(tab.getAttribute('data-i'), 10) || 0;
    galManual(g, i);
    var track = $('[data-ss-gal-track]', g);
    if (track) { var sl = galSlides(track); var left = sl[i] ? sl[i].offsetLeft - sl[0].offsetLeft : i * track.clientWidth; track.scrollTo({ left: left, behavior: RM.matches ? 'auto' : 'smooth' }); galThumbIntoView(g); galProg(g, i); }
  };

  /* 1.ª interacción de la página: a partir de aquí la galería puede avanzar sola */
  if (!window.__ssInteracted) {
    var onFirst = function (e) {
      /* QA r2: un scroll de un contenedor (p. ej. fselReveal moviendo .ss-fsel) no es interacción de la clienta */
      if (e && e.type === 'scroll' && e.target !== document && e.target !== window && e.target !== document.documentElement) return;
      if (window.__ssInteracted) return;
      window.__ssInteracted = true;
      ['pointerdown', 'keydown', 'wheel', 'touchstart', 'scroll'].forEach(function (t) { window.removeEventListener(t, onFirst, true); });
      syncGalleries(document);
    };
    ['pointerdown', 'keydown', 'wheel', 'touchstart', 'scroll'].forEach(function (t) { window.addEventListener(t, onFirst, { capture: true, passive: true }); });
  }

  document.addEventListener('visibilitychange', function () {
    GALS.forEach(function (g) { if (document.hidden) galStop(g); else if (g.__ss && g.__ss.vis) galSchedule(g); });
  });

  /* ---------- zoom (<dialog>) ---------- */

  window.ssBuyZoom = function (btn) {
    var g = btn && btn.closest('[data-ss-gal]');
    var dlg = g && $('dialog.ss-zoom', g);
    var img = g && $('[data-ss-gal-img]', g);
    if (!dlg || !img) return;
    if (g.__ss && g.__ss.swiped) { g.__ss.swiped = false; return; }
    var z = $('[data-ss-zoom-img]', dlg);
    z.src = img.getAttribute('data-zoom') || img.currentSrc || img.src;
    z.alt = img.alt;
    if (g.__ss) galStop(g);
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    var center = function () {
      if (dlg.scrollWidth > dlg.clientWidth) dlg.scrollLeft = (dlg.scrollWidth - dlg.clientWidth) / 2;
      if (dlg.scrollHeight > dlg.clientHeight) dlg.scrollTop = (dlg.scrollHeight - dlg.clientHeight) / 2;
    };
    center();
    if (!z.complete) z.onload = function () { z.onload = null; center(); };
    if (!dlg.__ssClose) {
      dlg.__ssClose = true;
      dlg.onclose = function () { if (g.__ss && g.__ss.vis) galSchedule(g); btn.focus(); };
    }
  };

  /* ---------- acordeones de producto (no exclusivos, height 525 ms --ez-critical) ---------- */

  window.ssBuyAcc = function (btn) {
    var panel = btn && document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (panel.__ssT) { clearTimeout(panel.__ssT); panel.__ssT = null; }
    if (RM.matches) { panel.hidden = open; panel.style.height = ''; return; }
    if (!open) {
      panel.hidden = false;
      var h = panel.scrollHeight;
      panel.style.height = '0px';
      void panel.offsetHeight;
      panel.style.height = h + 'px';
      panel.__ssT = setTimeout(function () { panel.style.height = ''; panel.__ssT = null; }, 560);
    } else {
      panel.style.height = panel.scrollHeight + 'px';
      void panel.offsetHeight;
      panel.style.height = '0px';
      panel.__ssT = setTimeout(function () { panel.hidden = true; panel.style.height = ''; panel.__ssT = null; }, 560);
    }
  };

  /* ---------- ciclo de vida ---------- */

  function fselReveal(root) {
    $$('.ss-fsel', root).forEach(function (sel) {
      if (sel.scrollWidth <= sel.clientWidth + 1) return;
      var on = $('.ss-fpill[aria-current="page"], .ss-fpill[aria-pressed="true"]', sel);
      /* QA r2: si la activa está agotada no se desplaza, para que se vean primero las que sí se pueden comprar */
      if (!on || on.classList.contains('is-sold')) return;
      var a = on.getBoundingClientRect(), b = sel.getBoundingClientRect();
      var pad = 25;
      if (a.right > b.right - pad) sel.scrollLeft += a.right - b.right + pad;
      else if (a.left < b.left + pad) sel.scrollLeft -= b.left + pad - a.left;
    });
  }

  window.ssBuyInit = function (root) {
    root = root || document;
    try { fselReveal(root); } catch (e) {}
    $$('[data-ss-gal]', root).forEach(initGal);
    $$('[data-ss-sticky]', root).forEach(initSticky);
    window.ssReapplyFreq(root);
  };

  window.ssBuyTeardown = function (root) {
    root = root || document;
    $$('[data-ss-gal]', root).forEach(function (g) {
      galStop(g);
      if (g.__ss && g.__ss.io) g.__ss.io.disconnect();
      var k = GALS.indexOf(g);
      if (k > -1) GALS.splice(k, 1);
      g.__ss = null;
      g.removeAttribute('data-ss-buy-ready');
    });
    $$('[data-ss-sticky]', root).forEach(function (st) {
      if (st.__ss) { st.__ss.ios.forEach(function (io) { io.disconnect(); }); st.__ss.off(); st.__ss = null; }
      st.removeAttribute('data-ss-buy-ready');
    });
    $$('dialog.ss-zoom[open]', root).forEach(function (d) { try { d.close(); } catch (e) {} });
    $$('.ss-acc__panel', root).forEach(function (p) { if (p.__ssT) { clearTimeout(p.__ssT); p.__ssT = null; } });
  };

  /* Contrato con ss-motion.js (C1): este archivo carga antes y define ssInit/ssTeardown; ss-motion las envuelve
     para añadir su parte (reveals, marquesinas…). Sin ss-motion, siguen haciendo el init/teardown de la compra. */
  if (typeof window.ssInit !== 'function') window.ssInit = function (r) { window.ssBuyInit(r); };
  if (typeof window.ssTeardown !== 'function') window.ssTeardown = function (r) { window.ssBuyTeardown(r); };

  function boot() {
    window.ssBuyInit(document);

    /* ?f=<handle> solo por JS al cargar (enlaces externos: Ads, IG) — pliego §2.8. */
    try {
      var f = new URLSearchParams(window.location.search).get('f');
      var buy = document.querySelector('[data-ss-buy="home"]');
      if (f && buy) pickPanel(buy, f.replace(/[^a-z0-9-]/gi, ''));
    } catch (e) {}

    if (document.querySelector('[data-ss-buy="pdp"]') && window.history && window.history.replaceState && !(history.state && history.state.ssSwap)) {
      try { history.replaceState({ ssSwap: 1 }, '', window.location.href); } catch (e) {}
    }

    /* Dawn restablece la etiqueta del botón en algunos flujos: solo se reaplica la cadencia (no el init completo). */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { window.ssReapplyFreq(document); });
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { __adding = false; window.ssReapplyFreq(document); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();




